import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminDashboard() {
  const [certs, setCerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Function to fetch certificates
  const fetchCertificates = async () => {
    setLoading(true);
    setError(null);
    
    try {
      console.log("Fetching certificates...");
      
      const response = await fetch("https://dvrinstitute.com/api/get_certificates.php", {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      });

      console.log("Response status:", response.status);
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("API Response:", data);

      // Handle different response formats
      if (Array.isArray(data)) {
        setCerts(data);
      } else if (data && data.success && Array.isArray(data.data)) {
        setCerts(data.data);
      } else if (data && data.data && Array.isArray(data.data)) {
        setCerts(data.data);
      } else {
        console.warn("Unexpected format, setting empty array");
        setCerts([]);
      }

    } catch (err) {
      console.error("Fetch error:", err);
      setError(err.message || "Failed to fetch certificates");
      setCerts([]);
    } finally {
      setLoading(false);
    }
  };

  // Function to handle certificate issuance
  // Function to handle certificate issuance - UPDATED VERSION
const handleIssue = async (id, studentName, course) => {
  try {
    if (!window.confirm(`Issue certificate for ${studentName} - ${course}?`)) {
      return;
    }

    console.log("Issuing certificate ID:", id);
    
    // Use GET method with timeout
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 30000);
    
    const response = await fetch(`https://dvrinstitute.com/api/issue_certificate.php?id=${id}`, {
      method: 'GET',
      signal: controller.signal
    });

    clearTimeout(timeoutId);
    
    console.log("Issue response status:", response.status);
    
    // Get response as text first for better error handling
    const text = await response.text();
    console.log("Raw response text:", text);
    
    let result;
    try {
      result = JSON.parse(text);
      console.log("Parsed JSON:", result);
    } catch (parseError) {
      console.error("JSON parse error:", parseError);
      alert(`❌ Invalid response from server. Please check the issue_certificate.php file.\n\nServer returned: ${text.substring(0, 200)}`);
      return;
    }
    
    if (result.success) {
      let message = `✅ Certificate issued successfully!\n\n` +
                   `Student: ${result.student_name}\n` +
                   `Course: ${result.course}\n` +
                   `Certificate Code: ${result.certificate_code}\n` +
                   `Verify URL: ${result.verify_url}\n`;
      
      if (result.qr_path) {
        message += `\nQR Code: ${result.qr_path}`;
        
        // Auto-open QR code after a short delay
        setTimeout(() => {
          if (window.confirm("Do you want to view the QR code?")) {
            const qrUrl = `https://dvrinstitute.com/api/qr_codes/${result.qr_path}`;
            window.open(qrUrl, '_blank');
          }
        }, 500);
      } else if (result.qr_warning) {
        message += `\n⚠️ ${result.qr_warning}`;
      }
      
      alert(message);
      
      // Refresh the list
      fetchCertificates();
      
    } else {
      alert(`❌ Failed to issue certificate:\n\n${result.error || result.message || "Unknown error"}`);
    }
  } catch (err) {
    console.error("Issue error details:", err);
    
    if (err.name === 'AbortError') {
      alert("❌ Request timeout. The server is taking too long to respond.");
    } else {
      alert(`❌ Network error: ${err.message}\n\nCheck if the issue_certificate.php file exists and is working.`);
    }
  }
};

  // Function to handle certificate deletion
  const handleDelete = async (id, studentName) => {
    if (!window.confirm(`Are you sure you want to delete certificate for ${studentName}?`)) {
      return;
    }

    try {
      const response = await fetch(`https://dvrinstitute.com/api/delete_certificate.php?id=${id}`, {
        method: 'DELETE',
      });

      const result = await response.json();
      
      if (result.success) {
        alert("Certificate deleted successfully!");
        fetchCertificates(); // Refresh the list
      } else {
        alert(`Failed to delete: ${result.message || "Unknown error"}`);
      }
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete certificate. Please check console for details.");
    }
  };

  // Function to download QR code


 // Function to download QR code - FIXED
// Function to download QR code - WITH FALLBACK
// Function to download QR code with fallback
const downloadQRCode = (certificate) => {
  if (!certificate.qr_path) {
    alert("QR code not available for this certificate");
    return;
  }

  const qrUrl = `https://dvrinstitute.com/api/qr_codes/${certificate.qr_path}`;
  const fallbackUrl = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=https://dvrinstitute.com/verify/${certificate.certificate_code}`;
  
  // Create a test image to check if it loads
  const testImage = new Image();
  testImage.onload = function() {
    // Image loads successfully
    const link = document.createElement('a');
    link.href = qrUrl;
    link.download = `QR_${certificate.student_name}_${certificate.course}.png`;
    link.target = '_blank';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  testImage.onerror = function() {
    // Use fallback
    const link = document.createElement('a');
    link.href = fallbackUrl;
    link.download = `QR_${certificate.student_name}_${certificate.course}.png`;
    link.target = '_blank';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    alert("Using online QR generator as fallback");
  };
  
  testImage.src = qrUrl;
};

// Helper function for download
const downloadFile = (url, certificate) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = `QR_${certificate.student_name}_${certificate.course}_${certificate.certificate_code || certificate.id}.png`;
  link.target = '_blank';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


// Add this function to your AdminDashboard.js
const testQRImage = (certificate) => {
  if (!certificate.qr_path) {
    alert("No QR path for this certificate");
    return;
  }
  
  const qrUrl = `https://dvrinstitute.com/api/qr_codes/${certificate.qr_path}`;
  
  console.log("Testing QR URL:", qrUrl);
  
  // Check if image loads
  const img = new Image();
  img.onload = function() {
    console.log("✅ QR image loads successfully");
    console.log("Image dimensions:", this.width, "x", this.height);
    alert(`✅ QR image loads successfully!\n\nURL: ${qrUrl}\nSize: ${this.width}x${this.height}px`);
  };
  
  img.onerror = function() {
    console.log("❌ QR image failed to load");
    
    // Check HTTP headers
    fetch(qrUrl, { method: 'HEAD' })
      .then(response => {
        console.log("HTTP Status:", response.status);
        console.log("Content-Type:", response.headers.get('content-type'));
        console.log("Headers:", Object.fromEntries(response.headers.entries()));
        
        alert(`❌ QR image failed to load\n\nURL: ${qrUrl}\nStatus: ${response.status}\nContent-Type: ${response.headers.get('content-type')}`);
      })
      .catch(err => {
        console.log("Fetch error:", err);
        alert(`❌ Cannot access QR URL\n\nURL: ${qrUrl}\nError: ${err.message}`);
      });
  };
  
  img.src = qrUrl;
};

// Function to preview QR code with error handling
const previewQRCode = (certificate) => {
  if (!certificate.qr_path) {
    alert("QR code not available for this certificate");
    return;
  }

  const qrUrl = `https://dvrinstitute.com/api/qr_codes/${certificate.qr_path}`;
  const fallbackUrl = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=https://dvrinstitute.com/verify/${certificate.certificate_code}`;
  
  console.log("Trying QR URL:", qrUrl);
  
  // First check if the file exists
  fetch(qrUrl, { method: 'HEAD' })
    .then(response => {
      if (response.ok && response.headers.get('content-type')?.includes('image')) {
        // File exists and is an image
        window.open(qrUrl, '_blank');
      } else {
        // Use fallback QR generator
        console.log("Local QR not found, using fallback");
        window.open(fallbackUrl, '_blank');
      }
    })
    .catch(err => {
      console.error("QR check failed, using fallback:", err);
      window.open(fallbackUrl, '_blank');
    });
};



  // Function to copy verification URL
  // Function to copy verification URL - IMPROVED
const copyVerificationUrl = (certificate) => {
  let verifyUrl = '';
  
  if (certificate.certificate_code) {
    verifyUrl = `https://dvrinstitute.com/verify/${certificate.certificate_code}`;
  } else if (certificate.id) {
    verifyUrl = `https://dvrinstitute.com/verify/${certificate.id}`;
  } else {
    alert("Verification URL not available - No certificate code or ID found");
    return;
  }
  
  navigator.clipboard.writeText(verifyUrl)
    .then(() => {
      alert(`✅ Verification URL copied to clipboard!\n\n${verifyUrl}`);
    })
    .catch(err => {
      console.error("Failed to copy: ", err);
      // Fallback method for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = verifyUrl;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        alert(`✅ Verification URL copied!\n\n${verifyUrl}`);
      } catch (copyErr) {
        alert(`❌ Failed to copy URL. Please copy manually:\n\n${verifyUrl}`);
      }
      document.body.removeChild(textArea);
    });
};


// Debug function to test QR URLs
const testQrUrl = (certificate) => {
  if (!certificate.qr_path) {
    alert("No QR path for this certificate");
    return;
  }
  
  const qrUrl = `https://dvrinstitute.com/api/qr_codes/${certificate.qr_path}`;
  const oldQrUrl = `https://dvrinstitute.com/api/qr/${certificate.qr_path}`;
  
  console.log("Testing QR URLs for certificate:", certificate);
  console.log("Current QR URL:", qrUrl);
  console.log("Old QR URL:", oldQrUrl);
  
  // Test both URLs
  fetch(qrUrl, { method: 'HEAD' })
    .then(response => {
      console.log("New QR URL status:", response.status, response.ok ? "✅ OK" : "❌ Failed");
    })
    .catch(err => {
      console.log("New QR URL error:", err.message);
    });
    
  fetch(oldQrUrl, { method: 'HEAD' })
    .then(response => {
      console.log("Old QR URL status:", response.status, response.ok ? "✅ OK" : "❌ Failed");
    })
    .catch(err => {
      console.log("Old QR URL error:", err.message);
    });
    
  alert(`QR Debug Info logged to console.\n\nCurrent URL: ${qrUrl}\nOld URL: ${oldQrUrl}`);
};

  useEffect(() => {
    fetchCertificates();
  }, []);

  // Function to format date
  const formatDate = (dateString) => {
    if (!dateString) return "Not issued";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div style={{ padding: 20, textAlign: 'center' }}>
        <h3>Loading certificates...</h3>
        <p>Please wait while we fetch the data.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: 20, maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
        <h2>📊 Admin Dashboard</h2>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button 
            onClick={fetchCertificates}
            style={{ 
              backgroundColor: '#4CAF50', 
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '5px'
            }}
          >
            🔄 Refresh
          </button>
          <button 
            onClick={() => navigate("/add-certificate")}
            style={{ 
              backgroundColor: '#2196F3', 
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '5px'
            }}
          >
            ➕ Add Certificate
          </button>
        </div>
      </div>

      {error && (
        <div style={{ 
          backgroundColor: '#ffebee', 
          color: '#c62828',
          padding: '15px',
          borderRadius: '4px',
          marginBottom: '20px',
          border: '1px solid #ef9a9a'
        }}>
          <strong>Error:</strong> {error}
          <div style={{ marginTop: '10px' }}>
            <button 
              onClick={fetchCertificates}
              style={{ 
                backgroundColor: '#c62828',
                color: 'white',
                padding: '5px 15px',
                border: 'none',
                borderRadius: '3px',
                cursor: 'pointer'
              }}
            >
              Retry
            </button>
          </div>
        </div>
      )}

      <div style={{ 
        backgroundColor: '#f5f5f5', 
        padding: '15px', 
        borderRadius: '4px',
        marginBottom: '20px',
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '10px'
      }}>
        <div>
          <strong>Total Certificates:</strong> {certs.length}
        </div>
        <div>
          <strong>Issued:</strong> {certs.filter(c => Number(c.is_issued) === 1).length}
        </div>
        <div>
          <strong>Pending:</strong> {certs.filter(c => Number(c.is_issued) === 0).length}
        </div>
        <div>
          <strong>With QR:</strong> {certs.filter(c => c.qr_path).length}
        </div>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ 
          width: '100%', 
          borderCollapse: 'collapse',
          backgroundColor: 'white',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#f8f9fa' }}>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #dee2e6', fontWeight: '600' }}>#</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #dee2e6', fontWeight: '600' }}>Student Name</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #dee2e6', fontWeight: '600' }}>Course</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #dee2e6', fontWeight: '600' }}>Certificate Code</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #dee2e6', fontWeight: '600' }}>Status</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #dee2e6', fontWeight: '600' }}>Issue Date</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #dee2e6', fontWeight: '600' }}>QR Code</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #dee2e6', fontWeight: '600' }}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {certs.length === 0 ? (
              <tr>
                <td colSpan="8" style={{ padding: '40px', textAlign: 'center', color: '#6c757d' }}>
                  <div style={{ fontSize: '48px', marginBottom: '10px' }}>📭</div>
                  <h3>No certificates found</h3>
                  <p>Add your first certificate using the "Add Certificate" button above.</p>
                </td>
              </tr>
            ) : (
              certs.map((c, index) => (
                <tr key={c.id} style={{ borderBottom: '1px solid #dee2e6' }}>
                  <td style={{ padding: '12px' }}>{index + 1}</td>
                  <td style={{ padding: '12px', fontWeight: '500' }}>{c.student_name}</td>
                  <td style={{ padding: '12px' }}>{c.course}</td>
                  <td style={{ padding: '12px' }}>
                    {c.certificate_code ? (
                      <code style={{ 
                        fontSize: '12px', 
                        backgroundColor: '#f0f0f0', 
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontFamily: 'monospace'
                      }}>
                        {c.certificate_code}
                      </code>
                    ) : 'N/A'}
                  </td>
                  <td style={{ padding: '12px' }}>
                    <span style={{
                      padding: '4px 12px',
                      borderRadius: '12px',
                      fontSize: '12px',
                      fontWeight: '600',
                      backgroundColor: Number(c.is_issued) === 1 ? '#d4edda' : '#fff3cd',
                      color: Number(c.is_issued) === 1 ? '#155724' : '#856404'
                    }}>
                      {Number(c.is_issued) === 1 ? '✅ Issued' : '⏳ Pending'}
                    </span>
                  </td>
                  <td style={{ padding: '12px', color: '#6c757d' }}>
                    {formatDate(c.issue_date)}
                  </td>
                  <td style={{ padding: '12px' }}>
                    {c.qr_path ? (
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button
                          onClick={() => previewQRCode(c)}
                          style={{ 
                            backgroundColor: '#6f42c1',
                            color: 'white',
                            padding: '6px 12px',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px'
                          }}
                          title="Preview QR Code"
                        >
                          👁️ Preview
                        </button>
                        <button
                          onClick={() => downloadQRCode(c)}
                          style={{ 
                            backgroundColor: '#20c997',
                            color: 'white',
                            padding: '6px 12px',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px'
                          }}
                          title="Download QR Code"
                        >
                          ⬇️ Download
                        </button>
                      </div>
                    ) : (
                      <span style={{ color: '#6c757d', fontSize: '12px' }}>No QR</span>
                    )}
                  </td>
                  <td style={{ padding: '12px' }}>
                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                      {/* Issue/Generate Button */}
                      {Number(c.is_issued) === 0 ? (
                        <button
                          onClick={() => handleIssue(c.id, c.student_name, c.course)}
                          style={{ 
                            backgroundColor: '#007bff',
                            color: 'white',
                            padding: '6px 12px',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px'
                          }}
                        >
                          🎫 Issue
                        </button>
                      ) : (
                        <button
                          onClick={() => copyVerificationUrl(c)}
                          style={{ 
                            backgroundColor: '#17a2b8',
                            color: 'white',
                            padding: '6px 12px',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px'
                          }}
                        >
                          📋 Copy Verify URL
                        </button>
                      )}
                      
                      {/* View PDF Button */}
                      {Number(c.is_issued) === 1 && (
                        <a
                          href={`https://dvrinstitute.com/api/generate_certificate_pdf.php?id=${c.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ 
                            backgroundColor: '#e83e8c',
                            color: 'white',
                            padding: '6px 12px',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            textDecoration: 'none',
                            fontSize: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px'
                          }}
                        >
                          📄 View PDF
                        </a>
                      )}
                      
                      {/* Delete Button */}
                      <button
                        onClick={() => handleDelete(c.id, c.student_name)}
                        style={{ 
                          backgroundColor: '#dc3545',
                          color: 'white',
                          padding: '6px 12px',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px'
                        }}
                      >
                        🗑️ Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {certs.length > 0 && (
        <div style={{ 
          marginTop: '20px', 
          textAlign: 'center', 
          color: '#6c757d',
          fontSize: '14px'
        }}>
          Showing {certs.length} certificate{certs.length !== 1 ? 's' : ''}
        </div>
      )}

      {/* QR Code Instructions */}
      <div style={{ 
        marginTop: '30px', 
        padding: '20px', 
        backgroundColor: '#f8f9fa', 
        borderRadius: '4px',
        borderLeft: '4px solid #007bff'
      }}>
        <h4>📱 QR Code Instructions</h4>
        <p><strong>For issued certificates with QR codes:</strong></p>
        <ol style={{ marginLeft: '20px', marginTop: '10px' }}>
          <li><strong>Preview:</strong> View the QR code in browser</li>
          <li><strong>Download:</strong> Save the QR code as PNG file</li>
          <li><strong>Verify URL:</strong> Copy the verification link to share</li>
          <li><strong>PDF:</strong> View/download the complete certificate</li>
        </ol>
        <p style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
          Note: QR codes are automatically generated when you issue a certificate.
        </p>
      </div>

      {/* Debug Section (optional) */}
      <div style={{ marginTop: '30px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
        <h4>🛠️ Debug Information</h4>
        <button 
          onClick={() => {
            console.log("Current certificates state:", certs);
            console.log("Certificates with QR:", certs.filter(c => c.qr_path).map(c => ({
              id: c.id,
              name: c.student_name,
              qr_path: c.qr_path
            })));
          }}
          style={{ 
            backgroundColor: '#6c757d',
            color: 'white',
            padding: '8px 16px',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '12px'
          }}
        >
          Show Debug Info in Console
        </button>
      </div>
    </div>
  );
}